import { AccrediblePageData, AccrediblePageParams } from '@accredible-frontend-v2/models';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { EditorVersion, EmailTemplate } from '../../entities/email-templates.model';
import { DashboardApiService } from '../db-api.service';

export interface EmailTemplatesParams extends AccrediblePageParams {
  template_type?: EditorVersion;
  source?: boolean;
  category?: 'spotlight_directory' | 'essential';
}

@Injectable({
  providedIn: 'root',
})
export class EmailTemplatesApiService extends DashboardApiService {
  readonly emailTemplatesUrl = `/v1/issuer/organizations/${this.embedding.departmentId}/email_templates`;

  loadEmailTemplates(
    pageParams: EmailTemplatesParams,
  ): Observable<AccrediblePageData<EmailTemplate>> {
    let queryParams = `?page_size=${pageParams.page_size}&page=${pageParams.page}&template_type=${pageParams.template_type}&source=${pageParams.source}`;

    if (pageParams.category) {
      queryParams += `&category=${pageParams.category}`;
    }

    return this._get(this.emailTemplatesUrl + queryParams).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res) => this._handleError(res)),
    );
  }
}
